import { Menu } from "@mui/material";
import ContextMenuItem from "./ContextMenuItem";
import { setContextMenuOpened } from "../../actions/contextMenuActions";
import { useDispatch } from "react-redux";

const ContextMenu = ({open, options, originX, originY}) => {
    const dispatch = useDispatch();
    const handleClose = () => dispatch(setContextMenuOpened(false));

    return (
        <Menu
            open={open}
            onClose={handleClose}
            anchorReference="anchorPosition"
            anchorPosition={{top: originY, left: originX}}
        >
        {
            options && options.map((option, index) => <ContextMenuItem key={index} option={option} />)
        }
        </Menu>
    )
}

export default ContextMenu;